module.exports = __webpack_public_path__ + "static/media/2022.f18cf5b0.png";